const GET_EMAILS_LEFT_ERROR_TEXT = "redux_store:marketing.error.get_emails_left";
const SEND_EMAIL_ERROR_TEXT = "redux_store:marketing.error.send_email";
const ADD_MARKETING_IMAGE_ERROR_TEXT = "redux_store:marketing.error.add_image";

export const GET_EMAILS_LEFT_ERROR = GET_EMAILS_LEFT_ERROR_TEXT;
export const SEND_EMAIL_ERROR = SEND_EMAIL_ERROR_TEXT;
export const ADD_MARKETING_IMAGE_ERROR = ADD_MARKETING_IMAGE_ERROR_TEXT;


// WEBPACK FOOTER //
// ./src/errors/marketing.js